import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Tag,
  DatePicker,
  Tooltip,
  Input,
  Image,
  Select,
  Space,
  Modal,
} from "antd";
import React, { useState, useEffect, useContext } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import ShowTotal from "../../components/ShowTotal";
import moment from "moment";
import apiPath from "../../constants/apiPath";
import ConfirmationBox from "../../components/ConfirmationBox";
import lang from "../../helper/lang";
import useDebounce from "../../hooks/useDebounce";
import { AuthContext } from "../../context/AuthContext";
import { USERTYPE } from "../../constants/conts";
import { ExclamationCircleOutlined, UndoOutlined } from "@ant-design/icons";
import FilterBar, { FilterBarFilters } from "../../components/FilterBar";
import confirm from "antd/lib/modal/confirm";
import ViewReport from "./ViewReport";
import { Typography } from "antd";
import { useNavigate } from "react-router-dom";

function Index() {
  const sectionName = lang("Report");

  const { Link, Text } = Typography;
  const { RangePicker } = DatePicker;
  const { userProfile, userPermission } = useContext(AuthContext);
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selected, setSelected] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [reportModal, setReportModal] = useState(false);
  const debouncedSearchText = useDebounce(searchText, 300);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [userStatusModal, setUserStatusModal] = useState(false);
  const navigate = useNavigate();
  const [activityVisible, setActivityVisible] = useState(false);
  const [violationList, setViolationList] = useState([]);
  const [activityPagination, activitySetPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [filters, setFilters] = useState({
    status: undefined,
    severity: undefined,
    entityType: undefined,
  });
  const [showFilters, setShowFilters] = useState(false);
  const { Option } = Select;
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const isSuperAdmin = userProfile?.role === USERTYPE.SUPER_ADMIN;
  const isAddPermissionGranted =
    isSuperAdmin || userPermission?.BranchSection?.includes("add");

  const fetchData = (pagination, filters) => {
    const params = new URLSearchParams();
    if (startDate) {
      params.append("startDate", startDate);
    }
    if (endDate) {
      params.append("endDate", endDate);
    }
    if (debouncedSearchText) {
      params.append("search", debouncedSearchText);
    }

    // 🔃 Status
    if (filters.status !== undefined) {
      params.append("status", filters.status);
    }
    if (filters.severity !== undefined) {
      params.append("severity", filters.severity);
    }
    if (filters.entityType !== undefined) {
      params.append("entityType", filters.entityType);
    }
    // 📄 Pagination
    params.append("page", pagination?.current);
    params.append("limit", pagination?.pageSize);

    request({
      url: `${apiPath.listReports}?${params.toString()}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setList(() => data?.data);
        setPagination((prev) => ({
          current: pagination?.page,
          total: data?.total,
          pageSize: Number(data?.limit),
        }));
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  };

  const resetData = () => {
    setSearchText("");
    setStartDate("");
    setEndDate("");
    setFilters({
      status: undefined,
      severity: undefined,
      entityType: undefined,
    });
    setRefresh((prev) => !prev);
  };

  const handleChangeDate = (e) => {
    if (e != null) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    } else {
      setStartDate();
      setEndDate();
    }
  };

  const handleFilterChange = (filterName, value) => {
    setFilters((prev) => ({ ...prev, [filterName]: value }));
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleDelete = (id) => {
    setTimeout(() => {
      confirm({
        maskClosable: true,
        icon: <ExclamationCircleOutlined />,
        className: "tab_modal",
        cancelButtonProps: { color: "red" },
        content: (
          <p
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Are you sure you want to delete this report ?
          </p>
        ),
        onOk() {
          request({
            url: `${apiPath.deleteReport}/${id}`,
            method: "DELETE",
            data: {},
            onSuccess: (data) => {
              fetchData(pagination, filters);
              ShowToast(
                `${data.message || "Delete Report Successfully"}`,
                Severty.SUCCESS,
              );
            },
            onError: (error) => {
              const message = error.response.data.message;
              setLoading(false);
              ShowToast(message, Severty.ERROR);
            },
          });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const handleSendTemplate = (record) => {
    setSelected(record);
    setStatusModalOpen(true);
  };

  const handleUserStatus = (record) => {
    setSelected(record);
    setUserStatusModal(true);
  };

  const handleStatus = async (id, status) => {
    let success = false;
    await request({
      url: `${apiPath.changeUserStatus}/${id}`,
      method: "PUT",
      data: { status },
      onSuccess: (data) => {
        setUserStatusModal(false);
        success = true;
        ShowToast(
          `${data.message || "Status Changed Successfully"}`,
          Severty.SUCCESS,
        );
      },
    });
    if (success) {
      request({
        url: `${apiPath.createViolation}`,
        method: "POST",
        data: {
          userId: id,
          reportId: selected.reportId,
          severity: selected.severity,
          action: status,
        },
        onSuccess: (data) => {
          console.log("violation created sucessfully");
        },
      });
    }
  };

  const sendTemplate = async (id, templateName) => {
    let success = false;
    const rawResponse =
      selected.entityType === "USER"
        ? selected.entityDetails._id
        : selected.entityType === "POST"
          ? selected.entityDetails.userId
          : selected.entityDetails.admins;

    const response = rawResponse
      ? Array.isArray(rawResponse)
        ? rawResponse
        : [rawResponse]
      : [];

    await request({
      url: `${apiPath.sendTemplate}`,
      method: "POST",
      data: { userIds: response, template: templateName },
      onSuccess: (data) => {
        success = true;
        setStatusModalOpen(false);
        ShowToast(
          `${data.message || "Template send successfully"}`,
          Severty.SUCCESS,
        );
      },
      onError: (error) => {
        const message = error.response.data.message;
        setLoading(false);
        ShowToast(message, Severty.ERROR);
      },
    });

    if (success) {
      request({
        url: `${apiPath.createViolation}`,
        method: "POST",
        data: {
          userId: id,
          reportId: selected.reportId,
          severity: selected.severity,
          action: "WARN",
        },
        onSuccess: (data) => {
          console.log("violation created sucessfully");
        },
      });
    }
  };

  const getTargetUserId = (selected) => {
    if (!selected?.entityType || !selected?.entityDetails) return null;

    switch (selected.entityType) {
      case "USER":
        return selected.entityDetails._id;

      case "GROUP":
        return selected.entityDetails.createdBy; // group creator

      case "POST":
        return selected.entityDetails.userId; // post creator

      default:
        return null;
    }
  };

  const fetchViolationData = (pagination, id) => {
    setLoading(true);
    const params = new URLSearchParams();

    // 📄 Pagination
    params.append("page", pagination.current);
    params.append("limit", pagination.pageSize);

    request({
      url: `${apiPath.listViolationList}/${id}?${params.toString()}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setViolationList(data?.data?.data || []);
        activitySetPagination({
          current: pagination.current,
          total: data?.data?.total || 0,
          pageSize: Number(data?.data?.limit) || pagination.pageSize,
        });
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const columns = [
    {
      title: `Report ID`,
      key: "reportId",
      dataIndex: "reportId",
      width: "25%",
      render: (reportId) => {
        return reportId;
      },
    },
    {
      title: `Reporter Name`,
      key: "reporterDetails",
      dataIndex: "reporterDetails",
      width: "25%",
      render: (_, { reporterDetails }) => {
        return reporterDetails?.name ? reporterDetails?.name : "N/A";
      },
    },
    {
      title: "Report Entity Type",
      dataIndex: "entityType",
      key: "entityType",
      render: (_, { entityType }) => {
        return <span className="your-caption-class">{entityType || "-"}</span>;
      },
    },
    {
      title: "Entity Name / ID",
      width: "25%",
      render: (_, record) => {
        if (!record?.entityType || !record?.entityDetails) return "N/A";

        let label = "N/A";
        let route = null;
        let state = {};
        switch (record.entityType) {
          case "USER":
            label = record.entityDetails.username;
            route = `/admin/user-manager`;
            state = {
              username: record.entityDetails.username,
            };
            break;

          case "POST":
            label = record.entityDetails.postId;
            route = `/admin/post-manager`;
            state = {
              postId: record.entityDetails.postId,
            };
            break;

          case "GROUP":
            label = record.entityDetails.name;
            route = `/admin/group-manager`;
            state = {
              // groupId: record.entityDetails._id,
              groupName: record.entityDetails.name,
            };
            break;

          default:
            return "N/A";
        }

        return (
          <Link
            onClick={() => navigate(route, { state })}
            style={{ cursor: "pointer" }}
          >
            {label || "N/A"}
          </Link>
        );
      },
    },
    {
      title: `${lang("Status")}`,
      key: "isActive",
      width: "25%",
      render: (_, { status }) => {
        let color =
          status === "PENDING"
            ? "yellow"
            : status === "IN_REVIEW"
              ? "blue"
              : "green";
        return (
          <a>
            <Tag color={color} key={status}>
              {status === "PENDING"
                ? "Pending"
                : status === "IN_REVIEW"
                  ? "In-Review"
                  : "Resolved"}
            </Tag>
          </a>
        );
      },
    },
    {
      title: `Severity(Risk)`,
      key: "severity",
      width: "25%",
      render: (_, { severity }) => {
        let color =
          severity === "LOW"
            ? "orange"
            : severity === "MEDIUM"
              ? "yellow"
              : "red";
        return (
          <a>
            <Tag color={color} key={severity}>
              {severity === "LOW"
                ? "Low"
                : severity === "MEDIUM"
                  ? "Medium"
                  : "High"}
            </Tag>
          </a>
        );
      },
    },
    {
      title: `Reported On`,
      key: "createdAt",
      dataIndex: "createdAt",
      width: "25%",
      render: (createdAt) => moment(createdAt).format("DD-MM-YYYY"),
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
    {
      title: `${lang("Action")}`,

      render: (_, record) => {
        return (
          <>
            <Tooltip
              title={`View` + sectionName}
              color={"purple"}
              key={"viewtransaction"}
            >
              <Button
                onClick={() => {
                  setSelected(record);
                  setReportModal(true);
                }}
              >
                <i className="fa fa-light fa-eye"></i>
              </Button>
            </Tooltip>
            <Tooltip title="Delete Report">
              <Button onClick={() => handleDelete(record._id)}>
                <i className="fa fa-light fa-trash"></i>{" "}
              </Button>
            </Tooltip>
            <Tooltip title="Send Warning Template">
              <Button onClick={() => handleSendTemplate(record)}>
                <i className={`fa fa-solid fa-paper-plane`}></i>
              </Button>
            </Tooltip>
            <Tooltip
              title={
                record.entityType === "GROUP"
                  ? "Action against group creator"
                  : record.entityType === "USER"
                    ? "Action against user"
                    : record.entityType === "POST"
                      ? "Action against post creator"
                      : "Action"
              }
            >
              <span>
                <Button onClick={() => handleUserStatus(record)}>
                  <i className="fa fa-solid fa-ban"></i>
                </Button>
              </span>
            </Tooltip>
            <Tooltip title="View Violation History">
              <span>
                <Button
                  onClick={() => {
                    setActivityVisible(true);
                    fetchViolationData(
                      activityPagination,
                      getTargetUserId(record),
                    );
                  }}
                >
                  <i className="fa fa-solid fa-file"></i>
                </Button>
              </span>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const activityColumns = [
    {
      title: "Violator",
      dataIndex: "user",
      key: "user",
      width: 200,
      render: (_, { user, _id }) => {
        return (
          <>
            <a className="avatar-text">{user.username}</a>
          </>
        );
      },
    },
    {
      title: "Violation Severity",
      dataIndex: "severity",
      key: "severity",
      width: 220,
      render: (severity) => severity || "-",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 220,
      render: (action) => action || "-",
    },
    {
      title: "Admin Action Date",
      dataIndex: "createdAt",
      width: 220,
      render: (createdAt) => moment(createdAt).format("YYYY-MM-DD | HH:mm A"),
    },
  ];

  useEffect(() => {
    setLoading(true);
    fetchData(pagination, filters);
  }, [filters, refresh, startDate, endDate, debouncedSearchText]);

  return (
    <>
      <div className="tabled">
        <ViewReport
          open={reportModal}
          onClose={() => setReportModal(false)}
          report={selected}
        />
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={sectionName + ` ${lang("Manager")}`}
              extra={
                <FilterBar
                  showFilters={showFilters}
                  onToggle={() => setShowFilters((v) => !v)}
                />
              }
            >
              {showFilters && (
                <FilterBarFilters>
                  <Select
                    placeholder="Entity type"
                    value={filters.entityType}
                    onChange={(value) =>
                      handleFilterChange("entityType", value)
                    }
                    allowClear
                  >
                    <Option value="USER">User</Option>
                    <Option value="POST">Post</Option>
                    <Option value="GROUP">Group</Option>
                  </Select>
                  <Select
                    placeholder="Status"
                    value={filters.status}
                    onChange={(value) => handleFilterChange("status", value)}
                    allowClear
                  >
                    <Option value="PENDING">Pending</Option>
                    <Option value="IN_REVIEW">In-Review</Option>
                    <Option value="RESOLVED">Resolved</Option>
                  </Select>
                  <Select
                    placeholder="Severity"
                    value={filters.severity}
                    onChange={(value) => handleFilterChange("severity", value)}
                    allowClear
                  >
                    <Option value="LOW">Low</Option>
                    <Option value="MEDIUM">Medium</Option>
                    <Option value="HIGH">High</Option>
                  </Select>
                  <RangePicker
                    disabledDate={(current) =>
                      current && current.isAfter(moment().endOf("day"))
                    }
                    onChange={handleChangeDate}
                    value={
                      startDate && endDate
                        ? [moment(startDate), moment(endDate)]
                        : null
                    }
                  />
                  <Button
                    onClick={() => resetData()}
                    type="primary"
                    icon={<UndoOutlined />}
                  >
                    Reset
                  </Button>
                </FilterBarFilters>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  marginBottom: "10px",
                  flexWrap: "wrap",
                }}
              >
                <h4 className="text-right m-0">
                  {" "}
                  {pagination.total
                    ? ShowTotal(pagination.total)
                    : ShowTotal(0)}{" "}
                </h4>
              </div>

              <div className="table-responsive customPagination customPaginationmain-newwwww">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>

        {/* Status Update Modal */}
        <Modal
          open={statusModalOpen}
          footer={null}
          centered
          closable
          width={700}
          onCancel={() => setStatusModalOpen(false)}
        >
          <div style={{ textAlign: "center" }}>
            <p style={{ fontSize: 22, fontWeight: "bold", marginBottom: 20 }}>
              Send Warning Templates
            </p>
            <Space size="middle" className="report-warning-templates">
              <Button
                onClick={() =>
                  sendTemplate(getTargetUserId(selected), "spam_warning")
                }
              >
                SPAM warning template
              </Button>
              <Button
                onClick={() =>
                  sendTemplate(getTargetUserId(selected), "abuse_warning")
                }
              >
                ABUSE / HARASSMENT warning template
              </Button>
              <Button
                onClick={() =>
                  sendTemplate(getTargetUserId(selected), "misleading_warning")
                }
              >
                MISLEADING / OTHER warning template
              </Button>
            </Space>
          </div>
        </Modal>

        {/* Change User Status */}
        <Modal
          open={userStatusModal}
          footer={null}
          centered
          closable
          onCancel={() => setUserStatusModal(false)}
        >
          <div style={{ textAlign: "center" }}>
            <p style={{ fontSize: 22, fontWeight: "bold", marginBottom: 20 }}>
              Update User Status
            </p>

            <Space size="middle">
              {selected?.status !== "active" && (
                <Button
                  type="primary"
                  style={{ background: "#52c41a", borderColor: "#52c41a" }}
                  onClick={() =>
                    handleStatus(getTargetUserId(selected), "active")
                  }
                >
                  Active
                </Button>
              )}

              {selected?.status !== "suspended" && (
                <Button
                  type="primary"
                  style={{ background: "#faad14", borderColor: "#faad14" }}
                  onClick={() =>
                    handleStatus(getTargetUserId(selected), "suspended")
                  }
                >
                  Suspended
                </Button>
              )}

              {selected?.status !== "banned" && (
                <Button
                  type="primary"
                  danger
                  onClick={() =>
                    handleStatus(getTargetUserId(selected), "banned")
                  }
                >
                  Banned
                </Button>
              )}
            </Space>
          </div>
        </Modal>

        {/* Show Activity Logs */}
        <Modal
          open={activityVisible}
          width={700}
          title="User Violation History"
          onCancel={() => setActivityVisible(false)}
          footer={null}
          destroyOnClose
        >
          <Table
            loading={loading}
            columns={activityColumns}
            dataSource={violationList}
            pagination={activityPagination}
            onChange={fetchViolationData}
          />
        </Modal>
      </div>
    </>
  );
}

export default Index;
